import _taggedTemplateLiteral from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject;
import styled from 'styled-components';
import { mediaMin } from '@spa/shared/theme';
import { Wrapper as CarouselOverallWrapper, Carousel, Header } from '@spa/shared/components/SimpleCarousel/styles';
import { Wrapper as Placeholder } from '@spa/shared/components/Unisystem/Placeholder/styles';
export var Wrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1w4cuzy-0"
})(["display:flex;flex-direction:column;gap:", ";color:", ";button{width:fit-content;}", " ", "{", " flex-wrap:wrap;height:auto;", "{p{font-family:'IntervalNextReg',sans-serif;font-size:", ";line-height:", ";font-weight:600;}}", "{flex-basis:100%;", " .photo{width:229px;display:flex;flex-direction:column;", " min-height:100%;padding:", " 0;cursor:pointer;img{width:229px;height:160px;object-fit:cover;border-radius:", ";}span{font-size:", ";font-weight:600;line-height:", ";text-transform:capitalize;}}.placeholder{width:229px;display:flex;flex-direction:column;", " min-height:100%;padding:", " 0;cursor:pointer;", "{width:229px;height:160px;}.unit-name{font-size:", ";font-weight:600;line-height:", ";}}}}"], function (props) {
  return props.theme.space(5);
}, function (props) {
  return props.theme.overview.sharedSpacesAndAmenities.text.color;
}, mediaMin.extraSmallBreakpoint(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    button {\n      width: 100%;\n    }\n  "]))), CarouselOverallWrapper, function (_ref) {
  var theme = _ref.theme;
  return theme.gap(6);
}, Header, function (props) {
  return props.theme.rem(22);
}, function (props) {
  return props.theme.rem(26);
}, Carousel, function (_ref2) {
  var theme = _ref2.theme;
  return theme.gap(4);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.gap(2, 'column');
}, function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.space(3);
}, function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.rem(20);
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.gap(2, 'column');
}, function (props) {
  return props.theme.space(2);
}, Placeholder, function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.rem(20);
});
export var Title = /*#__PURE__*/styled.h2.withConfig({
  componentId: "sc-1w4cuzy-1"
})(["font-size:", ";line-height:", ";font-weight:600;"], function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.rem(20);
});